"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STUDENT_AND_EXCHANGE_VISITOR_NUMBER = exports.USCIS_ONLINE_ACCOUNT_NUMBER = exports.I94_ARRIVAL_DEPARTURE_RECORD_NUMBER = exports.PASSPORT_NUMBER = exports.TRAVEL_DOCUMENT_NUMBER = exports.A_NUMBER = exports.SSN = exports.ITIN = exports.EIN = void 0;
exports.EIN = "ein";
exports.ITIN = "itin";
exports.SSN = "ssn"; // Immigration

exports.A_NUMBER = "a_number";
exports.TRAVEL_DOCUMENT_NUMBER = "travel_document_number";
exports.PASSPORT_NUMBER = "passport_number";
exports.I94_ARRIVAL_DEPARTURE_RECORD_NUMBER = "i94_arrival_departure_record_number";
exports.USCIS_ONLINE_ACCOUNT_NUMBER = "uscis_online_account_number";
exports.STUDENT_AND_EXCHANGE_VISITOR_NUMBER = "student_and_exchange_visitor_number";